
import React, { useState, useEffect, useMemo } from "react";
import axios from "../api/axiosConfig";
import {
    Box,
    Pagination,
    Skeleton,
    Chip,
    Typography,
    Stack,
    Avatar,
    Divider,
    Tooltip,
    ToggleButton,
    Collapse,
    Grid,
    Paper,
    Card,
    CardContent,
} from "@mui/material";
// import Layout from "../components/Layout";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, InputBase } from "@mui/material";

import { useTheme, useMediaQuery } from "@mui/material";
import PaymentDetailModal from "../components/PaymentDetailModal";
import DataHelper, { getInitials, stringToColor } from "../utils/DataHelper";
import dayjs from "dayjs";

import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Tune } from "@mui/icons-material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export default function PaymentHistory() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const rowsPerPage = 100;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const [showFilter, setShowFilter] = useState(false)

    const [selectedStartDate, setSelectedStartDate] = useState(dayjs().startOf("month"));
    const [selectedEndDate, setSelectedEndDate] = useState(dayjs().endOf("month"));

    const handleOpenDetail = (row) => {
        setSelectedRecord(row);
        setModalOpen(true);
    };



    // ------------------------
    // 🔥 API CALL HERE
    // ------------------------
    const fetchData = async (query = {}) => {
        try {
            setLoading(true);
            const resp = await axios.get("/paymenthistory.php", {
                params: {
                    action: "showhistperdate",
                    startdate: selectedStartDate
                        ? selectedStartDate.format("YYYY-MM-DD")
                        : "2024-01-01",
                    enddate: selectedEndDate
                        ? selectedEndDate.format("YYYY-MM-DD")
                        : dayjs().format("YYYY-MM-DD"),
                },
            });

            // console.log("Respon API", resp.data.data)
            setRows(resp.data.data); // API must return array of rows
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };


    // Load initial data
    useEffect(() => {
        fetchData();
    }, [selectedStartDate, selectedEndDate]);

    // ------------------------
    // 🔍 Client-side filtering
    // ------------------------
    const filteredRows = useMemo(() => {

        if (!search) return rows;
        const term = search.toLowerCase();
        return rows.filter(
            (r) =>
                r.nama?.toLowerCase().includes(term) ||
                r.membercode?.toLowerCase().includes(term)
        );
    }, [rows, search]);

    const exportToExcel = () => {
        const exportData = filteredRows.map(row => ({
            ID: row.idjemaat,
            FullName: row.name_full,
            Nick: row.name_nick,
            Phone: row.phone_mobile,
            Status: row.status_jemaat,
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "MemberBetania");

        XLSX.writeFile(wb, "memberbetania.xlsx");
    };

    // ------------------------
    // 📄 Pagination (100 rows)
    // ------------------------

    const paginatedRows = useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        return filteredRows.slice(start, start + rowsPerPage);
    }, [filteredRows, page]);




    const totalSelected = rows.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );


    return (
        < >

            <Box
                sx={{
                    height: isMobile ? "calc(100dvh - 80px)" : "calc(100dvh - 26px)",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    // background:
                    //     "linear-gradient(180deg, rgba(248,250,252,0.9) 0%, rgba(248,250,252,1) 100%)",
                }}
            >

                <Box sx={{ px: isMobile ? 1.5 : 2.5, pt: isMobile ? 1.5 : 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 800,
                                    // color: "#0f172a",
                                    letterSpacing: "0.3px",
                                }}
                            >
                                History Pembayaran
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ color: "text.secondary", mt: 0.25 }}
                            >
                                Ringkasan transaksi dan aktivitas pembayaran jemaat
                            </Typography>
                        </Box>
                        <Box flex={1} />
                        <Tooltip title="Filter">
                            <ToggleButton
                                value="filters"
                                selected={showFilter}
                                size="small"
                                onChange={() => setShowFilter(!showFilter)}
                                sx={{
                                    height: 34,
                                    px: 1.25,
                                    borderRadius: 2,
                                    textTransform: "none",
                                    fontWeight: 600,
                                    gap: 1,
                                    transition: "0.2s ease",
                                    borderColor: "divider",
                                    "&.Mui-selected": {
                                        backgroundColor: "warning.main",
                                        color: "white",
                                        "&:hover": {
                                            backgroundColor: "warning.dark",
                                        },
                                    },
                                }}
                            >
                                <Tune fontSize="small" />
                                <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                    Filter
                                </Typography>
                            </ToggleButton>
                        </Tooltip>
                        <Tooltip title="Download">
                            <IconButton
                                onClick={exportToExcel}
                                size="small"
                                sx={{
                                    ml: 0.5,
                                    height: 34,
                                    width: 34,
                                    borderRadius: 2,
                                    backgroundColor: "success.main",
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "success.dark",
                                    },
                                    boxShadow: "0px 6px 14px rgba(16, 185, 129, 0.25)",
                                }}
                            >
                                <DownloadIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Stack>

                    <Grid container spacing={1.5} sx={{ mt: 2 }}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: 0,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    // background:
                                    //     "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                }}
                            >
                                <CardContent sx={{ p: 2 }}>
                                    <Typography variant="caption" color="text.secondary">
                                        Total Transaksi
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{ mt: 0.5, fontWeight: 800, 
                                            // color: "#0f172a" 
                                        }}
                                    >
                                        {filteredRows.length.toLocaleString()}
                                    </Typography>
                                    <Typography variant="caption" color="text.disabled">
                                        Data tersaring pada periode aktif
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: 0,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    // background:
                                    //     "linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)",
                                }}
                            >
                                <CardContent sx={{ p: 2 }}>
                                    <Typography variant="caption" color="text.secondary">
                                        Total Nominal
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        sx={{ mt: 0.5, fontWeight: 800,
                                            // color: "#0f172a"
                                         }}
                                    >
                                        {DataHelper.formatValue("N", totalSelected)}
                                    </Typography>
                                    <Typography variant="caption" 
                                    color="text.disabled">
                                        Akumulasi seluruh transaksi
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: 0,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    // background:
                                    //     "linear-gradient(135deg, #ffffff 0%, #eef2ff 100%)",
                                }}
                            >
                                <CardContent sx={{ p: 2 }}>
                                    <Typography variant="caption" color="text.secondary">
                                        Periode Aktif
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{ mt: 0.5, fontWeight: 700, 
                                            // color: "#0f172a" 
                                        }}
                                    >
                                        {selectedStartDate?.format("DD MMM YYYY")} –{" "}
                                        {selectedEndDate?.format("DD MMM YYYY")}
                                    </Typography>
                                    <Typography variant="caption" color="text.disabled">
                                        Gunakan filter untuk mengubah tanggal
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{ mt: 2 }} />

                {/* Google Search Box */}


                <Collapse in={showFilter}>
                    <Box sx={{ px: isMobile ? 1.5 : 2.5, py: 2 }}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                border: "1px solid",
                                borderColor: "divider",
                                // background: "#ffffff",
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Grid container spacing={1.5} alignItems="center">
                                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                        <DatePicker
                                            label="Start Date"
                                            value={selectedStartDate}
                                            onChange={(newValue) => setSelectedStartDate(newValue)}
                                            format="DD MMMM YYYY"
                                            slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                        <DatePicker
                                            label="End Date"
                                            value={selectedEndDate}
                                            onChange={(newValue) => setSelectedEndDate(newValue)}
                                            format="DD MMMM YYYY"
                                            slotProps={{ textField: { fullWidth: true, size: "small" } }}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                px: 2,
                                                py: 1,
                                                borderRadius: 2,
                                                // background: "#f8fafc",
                                                border: "1px solid #e2e8f066",
                                                transition: "0.2s ease",
                                                "&:hover": {
                                                    borderColor: "#cbd5f5",
                                                },
                                                "&:focus-within": {
                                                    borderColor: "#2563eb",
                                                    boxShadow: "0 0 0 3px rgba(37,99,235,0.18)",
                                                },
                                            }}
                                        >
                                            <SearchIcon sx={{ opacity: 0.6, mr: 1 }} />
                                            <InputBase
                                                placeholder="Cari nama atau kode jemaat..."
                                                value={search}
                                                onChange={(e) => {
                                                    setSearch(e.target.value);
                                                    setPage(1);
                                                }}
                                                sx={{ fontSize: "0.95rem", flex: 1 }}
                                            />
                                            {search.length > 0 && (
                                                <IconButton
                                                    onClick={() => setSearch("")}
                                                    size="small"
                                                    sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </LocalizationProvider>
                        </Paper>
                    </Box>
                </Collapse>





                {/* Main container */}
                {/* <Card sx={{ borderRadius: 0, overflow: "hidden", boxShadow: 1, mt: 2 }}>
                    <CardContent sx={{ p: 0,sx:{overflowX:'auto',background:'#DDDDDD'}    }}> */}

                <Box
                    sx={{
                        flex: 1,
                        overflowY: "auto",
                        mt: 1,
                        borderRadius: 1,
                        px: isMobile ? 1.5 : 2.5,
                        pb: 2,
                        WebkitOverflowScrolling: "touch",
                    }}
                >
                    {/* Skeleton Loader */}
                    {loading ? (
                        [...Array(12)].map((_, i) => (
                            <Skeleton
                                key={i}
                                variant="rectangular"
                                height={56}
                                sx={{ my: 0.6, borderRadius: 2 }}
                            />
                        ))
                    ) : (

                        <>


                            <Stack spacing={1.5}>

                                {paginatedRows.length === 0 ? (
                                    <Stack
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={1.5}
                                        sx={{
                                            py: 8,
                                            px: 3,
                                            border: "1px dashed #e0e0e0",
                                            borderRadius: 3,
                                            // backgroundColor: "#fafafa",
                                        }}
                                    >
                                        <ReceiptLongIcon
                                            sx={{ fontSize: 44, color: "text.disabled" }}
                                        />

                                        <Typography
                                            variant="subtitle1"
                                            fontWeight={600}
                                            color="text.primary"
                                        >
                                            Tidak ada transaksi
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            align="center"
                                            sx={{ maxWidth: 420 }}
                                        >
                                            Tidak ditemukan transaksi pembayaran untuk periode atau
                                            filter yang dipilih.
                                        </Typography>
                                    </Stack>
                                ) : (




                                    paginatedRows.map((row) => {
                                        const avatarColor = stringToColor(row.nama);

                                        return (
                                            <Paper
                                                key={row.paycode}
                                                onClick={() => handleOpenDetail(row)}
                                                sx={{
                                                    p: 2,
                                                    borderRadius: 3,
                                                    bgcolor: "background.paper",
                                                    border: "1px solid",
                                                    borderColor: "divider",
                                                    boxShadow: "0 8px 20px rgba(15,23,42,0.06)",
                                                    cursor: "pointer",
                                                    transition: "all .2s",
                                                    "&:hover": {
                                                        // bgcolor: "rgba(248,250,252,0.9)",
                                                        transform: "translateY(-2px)",
                                                        boxShadow: "0 12px 24px rgba(15,23,42,0.12)",
                                                    },
                                                }}
                                            >
                                                {/* Header */}
                                                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                                    {/* Avatar */}
                                                    <Avatar
                                                        sx={{
                                                            bgcolor: avatarColor,
                                                            color: "#fff",
                                                            fontWeight: 700,
                                                            width: 44,
                                                            height: 44,
                                                            fontSize: 15,
                                                        }}
                                                    >
                                                        {getInitials(row.nama)}
                                                    </Avatar>

                                                    <Box flex={1}>
                                                        {/* Name */}
                                                        <Typography
                                                            fontSize={18}
                                                            fontWeight={700}
                                                            lineHeight={1.3}
                                                            
                                                        >
                                                            {row.nama}
                                                        </Typography>

                                                        {/* Meta row */}
                                                        <Stack
                                                            direction="row"
                                                            spacing={1.5}
                                                            alignItems="center"
                                                            sx={{ mt: 0.5, color: "text.secondary" }}
                                                        >
                                                            <Typography variant="caption">
                                                                {dayjs(row.dtcreate).format("DD MMM YYYY, HH:mm")}
                                                            </Typography>

                                                            <Typography variant="caption">•</Typography>

                                                            <Typography
                                                                variant="caption"
                                                                fontWeight={600}
                                                                color="primary.main"
                                                            >
                                                                {row.paycode}
                                                            </Typography>
                                                        </Stack>

                                                        {/* Note */}
                                                        {row.note && (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    mt: 0.75,
                                                                    fontStyle: "italic",
                                                                    color: "text.secondary",
                                                                }}
                                                            >
                                                                “{row.note}”
                                                            </Typography>
                                                        )}

                                                        {/* Footer */}
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                mt: 0.75,
                                                                display: "block",
                                                                color: "text.disabled",
                                                            }}
                                                        >
                                                            Created by {row.createby}
                                                        </Typography>
                                                    </Box>

                                                    <Stack alignItems="flex-end" spacing={1}>
                                                        <Chip
                                                            label={DataHelper.formatValue("N", row.amount)}
                                                            color={"primary"}
                                                            size="medium"
                                                            sx={{
                                                                fontWeight: 700,
                                                                fontSize: 16,
                                                                px: 1,
                                                                // background:
                                                                //     "linear-gradient(135deg, rgba(37,99,235,0.15), rgba(37,99,235,0.05))",
                                                                border: "1px solid rgba(37,99,235,0.2)",
                                                            }}
                                                        />
                                                        <Typography variant="caption" color="text.secondary">
                                                            Klik untuk detail
                                                        </Typography>
                                                    </Stack>
                                                </Stack>

                                            </Paper>
                                        );
                                    })
                                )}
                            </Stack>



                        </>
                    )}

                </Box>
                {!loading && (
                    <Box
                        sx={{
                            flexShrink: 0,
                            borderTop: "1px solid",
                            borderColor: "divider",
                            // background: "#ffffff",
                            px: isMobile ? 1.5 : 2.5,
                            py: 1,
                            pb: "env(safe-area-inset-bottom)",
                        }}
                    >
                        <Stack
                            direction="row"
                            spacing={isMobile ? 0.75 : 2}
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            <Pagination
                                count={Math.ceil(filteredRows.length / rowsPerPage)}
                                page={page}
                                onChange={(e, v) => setPage(v)}
                                siblingCount={0}
                                boundaryCount={1}
                                shape="rounded"
                                size={isMobile ? "small" : "medium"}
                                sx={{
                                    "& .MuiPaginationItem-root": {
                                        borderRadius: "10px",
                                        fontSize: "13px",
                                        minWidth: "34px",
                                        height: "34px",
                                        // backgroundColor: "#f1f5f9",
                                    },
                                    "& .MuiPaginationItem-root:hover": {
                                        // backgroundColor: "#e2e8f0",
                                    },
                                    "& .Mui-selected": {
                                        // backgroundColor: "#0f172a !important",
                                        // color: "#fff",
                                    },
                                }}
                            />
                            <Box flex={1} />
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                            >
                                <Paper
                                    elevation={0}
                                    sx={{
                                        px: 2,
                                        py: 1,
                                        borderRadius: 2,
                                        border: "1px solid",
                                        borderColor: "divider",
                                        background: "#f8fafc",
                                        textAlign: "right",
                                    }}
                                >
                                    <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#0f172a" }}>
                                        {filteredRows.length.toLocaleString()}
                                    </Typography>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: "text.secondary" }}>
                                        Record
                                    </Typography>
                                </Paper>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        px: 2,
                                        py: 1,
                                        borderRadius: 2,
                                        border: "1px solid",
                                        borderColor: "divider",
                                        background: "#f8fafc",
                                        textAlign: "right",
                                    }}
                                >
                                    <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#0f172a" }}>
                                        {DataHelper.formatValue("N", totalSelected)}
                                    </Typography>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: "text.secondary" }}>
                                        Total
                                    </Typography>
                                </Paper>
                            </Stack>
                        </Stack>
                    </Box>
                )}
                {/* </CardContent>

                </Card> */}
            </Box >
            <PaymentDetailModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                data={selectedRecord}
            />
        </ >
    );
}


